<p>
  <strong>Your export is being processed.</strong> Reports are available to download from the 'My Exports' tab.
</p>

<button mat-button (click)="onOkClick()">OK</button>
<button mat-button [mat-dialog-close]="1">My Exports</button>
